<template>
  <b-form 
    id="privilege-extra-payload"
    @submit.prevent="onSubmitForm"
  >
    <b-row>
      <b-col cols="12">
        <b-card no-body
          class="mb-1">
          <b-card-header>
            <span class="information-header">Extra/Payload</span>
          </b-card-header>
          <div class="px-2">
            <div class="row">
              <div class="col-12">
                <div class="d-flex justify-content-end mt-2 mb-1">
                  <add-button
                    :btn-label="'Add'"
                    @click.native="openExtraPayloadListModal"
                  />
                </div>
                <div class="d-flex flex-wrap justify-content-end">
                  <div class="search-container mb-1">
                    <search :on-search-input="onSetValueSearch" />
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-12">
                <overlay-loading :loading="loading.tableData">
                  <template #content>
                    <b-table
                      :key="tableModeReorder + keyChange"
                      v-sortable-row="sortableRowOptions"
                      :fields="fields.extrapayloadTable"
                      :items="formData.extrapayloadTable"
                      responsive
                      bordered
                      borderless
                      sticky-header
                      show-empty
                      no-local-sorting
                      class="default-static-table text-center"
                      :class="tableModeReorder ? 'table-reorder' : null"                  
                    >
                      <template #cell(data_type)="data">
                        <div class="d-flex justify-content-center">
                          <div
                            class="status-datatype text-center"
                            :class="[
                              resolveClassDataTypeStatus(data.item.data_type),
                            ]"
                          >
                            {{ resolveDataTypeStatus(data.item.data_type) }}
                          </div>
                        </div>
                      </template>
                      <template #cell(value)="data">
                        <div class="d-flex justify-content-center">
                         {{resolveValueData(data.item)}}
                        </div>
                      </template>
                      <template #cell(actions)="data">
                        <div class="d-flex justify-content-center">
                          <b-button
                            variant="secondary"
                            class="banner-action mr-2"
                            @click="openExtraPayloadListModal(data.item,true)"
                          >
                            <edit-icon class="banner-group-action-svg iconEdit-btn" />
                          </b-button>
                          <b-button
                            variant="secondary"
                            class="banner-action mr-2"
                            @click="openDeleteWarningModal(data.item)"
                          >
                            <delete-icon class="banner-group-action-svg" />
                          </b-button>
                        </div>
                      </template>
                      <template #table-busy>
                        <overlay-loading :loading="true" />
                      </template>
                      <template #empty>
                        <card-no-item :text-no-img="'Item Not Found'" />
                      </template>
                    </b-table>
                  </template>
                </overlay-loading>
              </div>
            </div>
            <div class="row">
                <div class="col-12 mb-3">
                  <pagination-with-reorder
                    entity-editable
                    reordering
                    :pagination="pagination"
                    @reorder="onClickReorder"
                    @entityChange="onFilterEntity"
                    @pageChange="onPageChange"
                  />
                </div>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <!-- <reorder-modal
      :current-index="currentIndex"
      :reorder-action="reorderExtraPayload"
      @onCloseModal="closeModal"
    /> -->
    <manage-extra-payload-list-modal 
      v-if="modalType.manageExtraPayloadList"
      :is-edit="isEditExtraPayload"
      :form-data-obj="extrapayloadDetailItem"
      @onSubmit="saveExtraPayload"
      @onCloseModal="closeExtraPayloadListModal"
    />
    <div class="privilege-btn-wrp mt-2 mb-2">
      <div class="d-flex justify-content-center">
        <cancel-button
          class="mr-1"
          :btn-label="'Back'"
          @click.native="$emit('onPreviousStep')"
          stageBack
        />
        <save-button
          :type="'submit'"
          class="ml-1"
          :btn-label="'Finish'"
          @click.native="$router.push('/privilege/list')"
        />
      </div>
    </div>
  </b-form>
</template>

<script>
import EditIcon from '@/@core/components/svg/common/Edit.vue'
import DeleteIcon from '@/@core/components/svg/common/Trash.vue'
import Search from '@/views/components/search/Search.vue'
import PaginationWithReorder from '@/views/components/pagination/PaginationWithReorder.vue'
import Sortable from 'sortablejs'
import ReorderModal from '@/@core/components/reorder-modal/ReorderModal.vue'
import ManageExtraPayloadListModal from './modal/ManageExtraPayloadListModal.vue';
import usePrivilegeExtraPayload from '../hooks/usePrivilegeExtraPayload';

const createSortable = (el, options, vnode) => Sortable.create(el, {
  ...options,
})

const sortableRow = {
  name: 'sortableRow',
  bind(el, binding, vnode) {
    const table = el
    table._sortable = createSortable(
      table.querySelector('tbody'),
      binding.value,
      vnode,
    )
  },
}

export default {
  directives: {
    sortableRow,
  },
  components: {
    EditIcon,
    DeleteIcon,
    Search,
    ManageExtraPayloadListModal,
    PaginationWithReorder,
    ReorderModal
  },
  props: {
    isEdit: { type: Boolean, default: false },
    privilegeId: { type: Number, default: 0 },
  },
  setup(props) {
    const { 
        loading,
        fields,
        formData,
        modalType,
        pagination,
        isEditExtraPayload,
        extrapayloadDetailItem,
        keyChange,
        sortableRowOptions,
        currentIndex,
        tableModeReorder,
        closeModal,
        openExtraPayloadListModal,
        openDeleteWarningModal,
        closeExtraPayloadListModal,
        resolveDataTypeStatus,
        resolveClassDataTypeStatus,
        onSetValueSearch,
        onPageChange,
        onFilterEntity,
        onSubmitForm,
        saveExtraPayload,
        onClickReorder,
        reorderExtraPayload,
        resolveValueData
    } = usePrivilegeExtraPayload(props); //ctrl + spaceBar
    return {
        loading,
        fields,
        formData,
        modalType,
        pagination,
        isEditExtraPayload,
        extrapayloadDetailItem,
        keyChange,
        sortableRowOptions,
        currentIndex,
        tableModeReorder,
        closeModal,
        openExtraPayloadListModal,
        openDeleteWarningModal,
        closeExtraPayloadListModal,
        resolveDataTypeStatus,
        resolveClassDataTypeStatus,
        onSetValueSearch,
        onPageChange,
        onFilterEntity,
        onSubmitForm,
        saveExtraPayload,
        onClickReorder,
        reorderExtraPayload,
        resolveValueData
    };
  },
};
</script>

<style scoped>
@import '~@/assets/css/pages/default-static-table.css';
@import '~@/assets/css/override-styles/dynamic-fields.css';
@import '~@/assets/css/pages/privilege/privilege-extrapayload.css';
</style>
